// A stale open tab can outlive a deployment: the build it loaded referenced lazy-chunk
// hashes that a newer deploy has since overwritten, so fetching them 404s. Angular's
// SwUpdate.unrecoverable only catches this when the service worker itself notices; a
// router lazy-load import failure surfaces instead as a plain TypeError through
// Angular's ErrorHandler, with nothing listening for it otherwise.
const RELOAD_GUARD_KEY = 'stale_chunk_reload_attempted';

const STALE_CHUNK_PATTERN =
  /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk .* failed/i;

export const isStaleChunkError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error);
  return STALE_CHUNK_PATTERN.test(message);
};

// Guarded with sessionStorage so a genuinely broken deployment (chunks still missing
// after the reload) fails loudly on the second attempt instead of reload-looping forever.
export const recoverFromStaleChunk = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (sessionStorage.getItem(RELOAD_GUARD_KEY)) {
    return;
  }
  sessionStorage.setItem(RELOAD_GUARD_KEY, '1');

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      Promise.all(registrations.map((registration) => registration.unregister())).finally(() => {
        window.location.reload();
      });
    });
  } else {
    window.location.reload();
  }
};
